<template>
  <div class="container">
    <div class="login">
      <div class="base-content">
        <el-card class="card" shadow="always" :body-style="{ padding: '20px' }">
          <div slot="header">
            <span>登录</span>
          </div>
          <!-- card body -->
          <el-form :model="form" ref="form" :rules="rules" label-width="80px" :inline="false" size="normal">
            <el-form-item label="账号" prop="name">
              <el-input v-model="form.name" maxlength="16"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="pwd">
              <el-input type="password" v-model="form.pwd" maxlength="16"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">立即登录</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        name: "",
        pwd: ""
      },
      rules: {
        name: [
          { required: true, message: "请输入账号", trigger: "blur" },
          { min: 2, max: 16, message: "长度在 2 到 16 个字符", trigger: "blur" }
        ],
        pwd: [{ required: true, message: "请输入密码", trigger: "blur" }]
      },
      plates: ["云招商", "云项目", "投资军团", "真会投资"],
      patharr: {
        云招商: {
          项目: "/attract/project",
          户型: "/attract/house",
          房源: "/attract/houseinfo",
          经纪人: "/attract/user",
          设置: "/setting"
        },
        云项目: {
          楼盘: "/project/house",
          户型: "/project/house-type",
          楼盘置顶: "/project/stick",
          首页资讯: "/project/home-article",
          用户跟进: "/project/collect",
          客户: "/project/client",
          置业顾问: "/project/user",
          城市: "/project/city",
          文章: "/project/dynamic",
          公众号推文: "/project/article",
          公众号: "/project/official",
          设置: "/project/setting"
        },
        投资军团: {
          导师团: "/invest/tutor",
          活动: "/invest/activity",
          问答: "/invest/question",
          问卷调查: "/invest/survey",
          金融产品: "/invest/welfare",
          早报: "/invest/paper",
          法拍房: "/invest/foreclosure"
        },
        真会投资: {
          成员管理: "/applet/member",
          机器人: "/applet/robot",
          广告位设置: "/applet/advertising"
        }
      }
    };
  },
  methods: {
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          var params = {
            name: this.form.name,
            pwd: this.form.pwd
          };
          this.$api.login(params).then((data) => {
            console.log(data);
            this.$store.commit("setuser", data);
            let { permission } = data;
            var plateitem = "",
              platestr;
            for (let str of this.plates) {
              if (permission[str] && permission[str].length > 0) {
                plateitem = str;
                platestr = permission[str][0];
                break;
              }
            }
            var path = this.patharr[plateitem][platestr];
			      console.log(path,'----')
            this.$router.push({ path });
          });
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
